import { render } from "./LayoutSub.vue?vue&type=template&id=00721ef9&scoped=true"
import script from "./LayoutSub.vue?vue&type=script&lang=js"
export * from "./LayoutSub.vue?vue&type=script&lang=js"

import "./LayoutSub.vue?vue&type=style&index=0&id=00721ef9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00721ef9"]])

export default __exports__